// 切换皮肤
import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  useMemo,
  forwardRef,
} from "react";
import { injectIntl, useIntl } from "react-intl";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { produce } from "immer";
import { Iconfont } from "@/lib";
import sun from "@/assets/svg/sun.svg";
import sun1 from "@/assets/svg/sun1.svg";
import night from "@/assets/svg/night.svg";
import styles from "@/components/switchTheme.style.js";
import { makeStyles } from "tss-react/mui";
import { useTheme } from "@mui/material/styles";

import { usePageMode } from "@/model/usePageMode";

const useStyles = makeStyles()(styles);

let initState = {};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);

const CopyRC = (props, ref) => {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  const { mode, changePageMode } = usePageMode();

  const { palette } = useTheme();

  const [state, dispatch] = useReducer(reducer, initState);

  const change = (key) => () => {
    changePageMode(key);
  };

  return (
    <div className={classes.switch}>
      {mode == "light" ? (
        <svg data-src={night} width={24} height={24} onClick={change("dark")} />
      ) : (
        <svg data-src={sun} width={24} height={24} onClick={change("light")} />
      )}
    </div>
  );
};

export default forwardRef(CopyRC);
